import { useState } from 'react';

import { TagDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import PencilIcon from '@/components/icons/pencil';
import { Badge } from '@/components/ui/badge';

import { UpdateWorkspaceWorkOrderTags } from './update-workspace-work-order-tags';

function WorkOrderTags({
  onTagsChange,
  workOrderTags,
  disabled = false,
}: {
  onTagsChange: (tags: TagDTO[]) => void;
  workOrderTags: TagDTO[] | undefined;
  disabled?: boolean;
}) {
  const [openWorkOrderTagsUpdate, setOpenWorkOrderTagsUpdate] = useState(false);

  return (
    <div className="flex gap-2">
      <div className="min-w-[230px] text-sm">Work Order tags</div>
      <div className="flex flex-col gap-2">
        {workOrderTags && workOrderTags.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {workOrderTags.map((workOrderTag) => (
              <Badge key={workOrderTag.id} size="sm" variant="sky">
                {workOrderTag.tag}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-secondary-text text-sm">No Work Order tags have been created yet.</div>
        )}
        {!disabled && (
          <Button
            variant="ghost"
            type="button"
            icon={<PencilIcon />}
            className="bg-grey-1 hover:bg-grey-3 w-fit"
            onClick={() => {
              setOpenWorkOrderTagsUpdate(true);
            }}>
            Edit Tags
          </Button>
        )}
      </div>

      <UpdateWorkspaceWorkOrderTags
        workOrderTags={workOrderTags}
        open={openWorkOrderTagsUpdate}
        onOpenChange={setOpenWorkOrderTagsUpdate}
        callback={onTagsChange}
      />
    </div>
  );
}

export default WorkOrderTags;
